
import { gql } from "graphql-tag";

import VariationPrismic from "./VariationPrismic";
import VariationVariant from "./VariationVariant";
import VariationSearchspring from "./VariationSearchspring";

import { getProductCatalogueV2 } from "./fragment";

export default {
  name: "ProductCatalogueV2",

  components: {
    VariationPrismic,
    VariationVariant,
    VariationSearchspring,
  },

  inject: {
    uid: { default: "" },
    pageType: { default: "" },
    isCustomType: { default: true },
  },

  props: {
    slice: { type: Object, required: true },
    index: { type: Number, required: true },
    context: { type: Object, default: () => {} },
  },

  computed: {
    handle() {
      return this.$route.params?.handle;
    },
    query() {
      const pageType = this.pageType?.toLowerCase();
      const queryName = `${pageType}_product_catalogue_v2_${this.index}`;

      return gql`
        query ${queryName}($uid: String!, $lazy: Boolean!, $lang: String = "en-in") {
           ${this.pageType}:${pageType}(uid: $uid, lang: $lang) {
                ${this.isCustomType ? "slices:body" : "slices"} {
                  ... ${this.pageType}_product_catalogue_v2
                }
              }
            }
        ${getProductCatalogueV2(this.pageType, !this.isCustomType)}
      `;
    },
  },

  methods: {
    async getPrismicData() {
      const response = await this.$prismicGql.request({
        query: this.query,
        variables: { uid: this.uid, lazy: true },
      });

      const data = response?.[this.pageType];

      return data?.slices?.[this.index] ?? {};
    },
  },
};
